import {
  AmazonConnectFormDrawerContent,
  DelightedFormDrawerContent,
  DiscourseFormDrawerContent,
  EmailFormDrawerContent,
  FileUploadFormDrawerContent,
  FreshchatFormDrawerContent,
  FreshdeskFormDrawerContent,
  FrontFormDrawerContent,
  G2FormDrawerContent,
  KustomerFormDrawerContent,
  PlaystoreFormDrawerContent,
  QualtricsFormDrawerContent,
  SnowflakeFormDrawerContent,
  StellaConnectFormDrawerContent,
  WebhookFormDrawerContent,
  ZendeskChatFormDrawerContent,
  ZendeskSupportFormDrawerContent,
} from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent';
import { AppstoreFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/AppstoreFormDrawerContent';
import {
  IntegrationChannelType,
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';

const ChannelTypeToFormDrawerContentMap: Partial<
  Record<
    IntegrationChannelType,
    (props: GetAddIntegrationFormDrawerContentProps) => JSX.Element
  >
> = {
  [IntegrationChannelType.Appstore]: AppstoreFormDrawerContent,
  [IntegrationChannelType.Delighted]: DelightedFormDrawerContent,
  [IntegrationChannelType.Discourse]: DiscourseFormDrawerContent,
  [IntegrationChannelType.Email]: EmailFormDrawerContent,
  [IntegrationChannelType.FileUpload]: FileUploadFormDrawerContent,
  [IntegrationChannelType.Freshchat]: FreshchatFormDrawerContent,
  [IntegrationChannelType.FreshDesk]: FreshdeskFormDrawerContent,
  [IntegrationChannelType.Front]: FrontFormDrawerContent,
  [IntegrationChannelType.G2]: G2FormDrawerContent,
  [IntegrationChannelType.Kustomer]: KustomerFormDrawerContent,
  [IntegrationChannelType.Playstore]: PlaystoreFormDrawerContent,
  [IntegrationChannelType.Snowflake]: SnowflakeFormDrawerContent,
  [IntegrationChannelType.StellaConnect]: StellaConnectFormDrawerContent,
  [IntegrationChannelType.Webhook]: WebhookFormDrawerContent,
  [IntegrationChannelType.ZendeskChat]: ZendeskChatFormDrawerContent,
  [IntegrationChannelType.ZendeskSupport]: ZendeskSupportFormDrawerContent,
  [IntegrationChannelType.Qualtrics]: QualtricsFormDrawerContent,
  [IntegrationChannelType.AmazonConnect]: AmazonConnectFormDrawerContent,
};

export interface GetAddIntegrationFormDrawerContentProps {
  integrationChannel: IntegrationChannelViewFragment;
  integrationType: IntegrationType;
  onDrawerClose: () => void;
}

export const getAddIntegrationFormDrawerContent = ({
  integrationChannel,
  integrationType,
  onDrawerClose,
}: GetAddIntegrationFormDrawerContentProps) => {
  const AddIntegrationDrawerContent =
    ChannelTypeToFormDrawerContentMap[integrationChannel.type];

  if (!AddIntegrationDrawerContent) {
    return null;
  }

  return (
    <AddIntegrationDrawerContent
      integrationType={integrationType}
      integrationChannel={integrationChannel}
      onDrawerClose={onDrawerClose}
    />
  );
};
